/**
 * Created by Shiv Roy on 3/11/17.
 */

import { isEmptyObject } from "../../../actions/utilAction";

// Form validation
const validate = (values) => {
  const error = {};
  if (!values.zip || values.zip.trim() === '') {
    error.zip = 'Please enter zip.';
  }
  if (values.fax && values.fax.length < 14) {
    error.fax = 'Please enter correct fax.';
  }
  if (values.zip && values.zip.length < 5) {
    error.zip = 'Please enter correct zip.';
  }
  if (!values.name || values.name.trim() === '') {
    error.name = 'Please enter name.';
  }
  if (!values.address || values.address.trim() === '') {
    error.address = 'Please enter address.';
  }
  if (!values.city || values.city.trim() === '') {
    error.city = 'Please enter city.';
  }
  if (!values.stateID) {
    error.stateID = 'Please select state.';
  } else if (!Number.isInteger(values.stateID)) {
    error.stateID = 'Please select an option.';
  }
  if (!values.countryID) {
    error.countryID = 'Please select country.';
  } else if (!Number.isInteger(values.countryID)) {
    error.countryID = 'Please select an option.';
  }

  if (!values.insuranceTypeId) {
    error.insuranceTypeId = 'Please select insurance.';
  } else if (!Number.isInteger(values.insuranceTypeId)) {
    error.insuranceTypeId = 'Incorrect insurance type.';
  }
  // if (!values.phone) {
  //   error.phone = 'Please enter phone number.';
  // }
  if (values.phone && values.phone.length < 14) {
    error.phone = 'Please enter valid phone number.';
  }

  // if (!values.email || values.email.trim() === '') {
  //   error.email = 'Please enter email.';
  // }
  if (values.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,15}$/i.test(values.email)) {
    error.email = 'Please enter a valid email address.';
  }

  if (!values.UnitDuration) {
    error.UnitDuration = 'Please enter unit duration.';
  }
  if (!values.unitDuration) {
    error.unitDuration = 'Please enter unit duration.';
  }

  if (!values.UnitTypeID) {
    if (!Number.isInteger(values.UnitTypeID)) {
      error.UnitTypeID = 'Please select an option.';
    }
  }
  if (!values.unitTypeID) {
    error.unitTypeID = 'Please choose a unit type.';
  } else if (!Number.isInteger(values.unitTypeID)) {
    error.unitTypeID = 'Please select an option.';
  }

  if (!values.RatePerUnit) {
    error.RatePerUnit = 'Please enter rate per unit.';
  }

  if (!values.ServiceCodeId) {
    error.ServiceCodeId = 'Please enter Service code.';
  }

  if (!values.serviceCodeID) {
    error.serviceCodeID = 'Please enter Service code.';
  }
  if (!values.activityName) {
    error.activityName = 'Please select activity first.';
  }
  /*  if (!values.Modifier1) {
    error.Modifier1 = 'Please enter Modifier1.';
  }
  if (!values.Modifier2) {
    error.Modifier2 = 'Please enter Modifier2.';
  }
  if (!values.Modifier3) {
    error.Modifier3 = 'Please enter Modifier3.';
  }
  if (!values.Modifier4) {
    error.Modifier4 = 'Please enter Modifier4.';
  }*/
  if (!values.form1500PrintFormat) {
    error.form1500PrintFormat = 'Please choose print foramt.';
  } 

  if (values.payerBillingRateModel && values.payerBillingRateModel.length) {
    const payrollArrayErrors = [];
    //console.log('values.payerBillingRateModel............',values.payerBillingRateModel)
    values.payerBillingRateModel.forEach((Obj, index) => {
      const payrollErrors = {};      
     // console.log('Obj............',Obj)
      if (Obj !== undefined && !isEmptyObject(Obj) && Obj.startDate !== undefined && (!Obj.rate || parseFloat(Obj.rate || 0) === 0)) {
        payrollErrors.rate = 'Please enter rate';
      }
      if (Obj !== undefined && !isEmptyObject(Obj) && (!Obj.rate || parseFloat(Obj.rate || 0) > 0) && !Obj.startDate) {
        payrollErrors.startDate = 'Please enter from date';
      }
      payrollArrayErrors[index] = payrollErrors;
    });
    if (payrollArrayErrors.length) {
      error.payerBillingRateModel = payrollArrayErrors;
    }
  }
  if (values.customSignatureSettings) {
    let arr = [values.requiredStaffSignature,
      values.requiredGuardianSignature,
      values.requiredSupervisingClinicianSignature,
      values.doNotRequiredAnySignature];
      
    if (arr.includes(true)) {
      error.customSignatureSettings = null;
    }else{
      error.customSignatureSettings = "Please select at least one option from 'Custom signature settings'.";
    }
  }
  
  return error;
};

export default validate;



// WEBPACK FOOTER //
// ./src/modules/Payers/containers/validate.js